import Dialog from "components/ui/Dialog";
import Button from "components/ui/Button";
import { useTranslation } from "react-i18next";
import ErrorOutlineIcon from "../../../../images/payment_check_circle.svg?react";
import { PricingModelItem } from "../../../../services/pricingModel/model";
import { formatPrice, periodToString } from "services/pricingModel/utils";
import { DateFormat, useUserTimezone } from "utils/date";
import styles from "./PaymentSucceedModal.module.scss";

interface Props {
  onClose: () => void;
  plan: PricingModelItem;
}

// TODO: unite with PaymentFailedModal
export default function PaymentSucceedModal({ onClose, plan }: Props) {
  const { t } = useTranslation();
  const withTimezone = useUserTimezone();
  let text;
  if (plan.purchase_student_type === "self-study") {
    const period = periodToString(plan.length!);
    const nextPaymentDate = withTimezone
      .moment()
      .add(plan.length, "days")
      .format(DateFormat.fullDate);
    text = (
      <p>
        {t("Common.paymentResult.successSelfStudy", {
          price: formatPrice(plan.price, plan.currency),
          period,
          date: nextPaymentDate,
        })}
      </p>
    );
  } else {
    text = <p>{t("Common.paymentResult.successOneOnOne")}</p>;
  }

  return (
    <Dialog
      open
      size="sm"
      hideHeader
      aria-label={t("Common.paymentResult.successTitle")}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <div className={styles.container}>
        <div className={styles.actions}>
          <ErrorOutlineIcon />
          <p className={styles.header}>{t("Common.paymentResult.successTitle")}</p>
          {text}
          <Button size="large" onClick={onClose}>
            {t("Common.Continue")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
